import React from 'react';

// The styles the admin screens share, matching the Users and Activities screens.

export const screenStyle: React.CSSProperties = {
  backgroundColor: '#1a1a1a',
  minHeight: '100vh',
  padding: '40px 20px',
};

export const titleStyle: React.CSSProperties = {
  color: '#fff',
  textAlign: 'center',
  marginBottom: '30px',
};

export const panelStyle: React.CSSProperties = {
  padding: '16px',
  borderRadius: '12px',
  backgroundColor: '#242424',
  border: '1px solid #333',
};

export const inputStyle: React.CSSProperties = {
  height: '40px',
  padding: '0 12px',
  borderRadius: '8px',
  border: '1px solid #333',
  backgroundColor: '#2a2a2a',
  color: '#fff',
  fontSize: '0.9rem',
  boxSizing: 'border-box',
  width: '100%',
};

export const labelStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  color: '#999',
  fontSize: '0.8rem',
};

const buttonBaseStyle: React.CSSProperties = {
  padding: '10px 18px',
  borderRadius: '8px',
  fontWeight: 'bold',
  fontSize: '0.85rem',
  cursor: 'pointer',
  flexShrink: 0,
};

export const primaryButtonStyle: React.CSSProperties = {
  ...buttonBaseStyle,
  backgroundColor: '#daff00',
  color: '#1a1a1a',
  border: '1px solid #daff00',
};

export const secondaryButtonStyle: React.CSSProperties = {
  ...buttonBaseStyle,
  backgroundColor: '#2a2a2a',
  color: '#fff',
  border: '1px solid #333',
};

export const dangerButtonStyle: React.CSSProperties = {
  ...buttonBaseStyle,
  backgroundColor: 'transparent',
  color: '#ff4d4d',
  border: '1px solid #ff4d4d',
};

export const disabledButtonStyle: React.CSSProperties = {
  ...secondaryButtonStyle,
  color: '#555',
  cursor: 'not-allowed',
};

export const badgeStyle: React.CSSProperties = {
  padding: '2px 10px',
  borderRadius: '999px',
  fontSize: '0.7rem',
  fontWeight: 'bold',
  backgroundColor: '#333',
  color: '#ddd',
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

export const errorStyle: React.CSSProperties = {
  color: '#ff4d4d',
  margin: '0 0 16px',
};

export const noticeStyle: React.CSSProperties = {
  color: '#daff00',
  margin: '0 0 16px',
};

export const messageStyle: React.CSSProperties = {
  color: '#666',
  textAlign: 'center',
  fontSize: '1.3rem',
  marginTop: '40px',
};

export const chipStyle = (selected: boolean): React.CSSProperties => ({
  padding: '6px 12px',
  borderRadius: '999px',
  fontSize: '0.8rem',
  cursor: 'pointer',
  border: `1px solid ${selected ? '#daff00' : '#333'}`,
  backgroundColor: selected ? '#daff00' : '#2a2a2a',
  color: selected ? '#1a1a1a' : '#ddd',
  fontWeight: selected ? 'bold' : 'normal',
});
